module.exports = __webpack_public_path__ + "static/media/bg-mobile.a15b5972.jpg";